import { useQuery } from 'urql';

import {
  Dimension1,
  type GetSentimentDataQuery,
  SENTIMENT_GET_OVERTIME_DATA_V2,
} from '@revelio/data-access';

interface UseSentimentEffectsResult {
  data: GetSentimentDataQuery | undefined;
  isLoading: boolean;
  error: string | null;
}

/**
 * Fetches full sentiment data (with count/weight) for a single company
 * using SENTIMENT_GET_OVERTIME_DATA_V2. This query returns the data shape
 * needed by the "Factors of Hiring / Factors of Attrition" effect bar chart.
 */
export const useSentimentEffects = (
  companyRcid: number | null
): UseSentimentEffectsResult => {
  const [{ data, fetching, error }] = useQuery({
    query: SENTIMENT_GET_OVERTIME_DATA_V2,
    variables: {
      filters: {
        company: companyRcid ? [companyRcid] : [],
      },
      dim1: Dimension1.Company,
    },
    pause: !companyRcid,
  });

  return {
    data,
    isLoading: fetching,
    error: error ? 'Failed to load sentiment effects data' : null,
  };
};
